"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var core_1 = require("@dynamynd/core");

var payments_1 = require("@dynamynd/payments");

var responsive_1 = require("@dynamynd/responsive");

var routes_1 = require("@dynamynd/routes");

var utilities_1 = require("@dynamynd/utilities");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var react_redux_1 = require("react-redux");

var redux_1 = require("redux");

var styled_components_1 = __importDefault(require("styled-components"));

var enums_1 = require("../../enums");

var store_1 = require("../../store");

var WithAdditionalContent =
/** @class */
function (_super) {
  __extends(WithAdditionalContent, _super);

  function WithAdditionalContent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      contentModalVisible: false,
      currentContent: enums_1.ContentPagesEnum.terms,
      purchaseData: {
        personId: '',
        outputGroupId: ''
      },
      purchaseDataCallback: function purchaseDataCallback() {
        return undefined;
      }
    };

    _this.toggleModal = function () {
      _this.setState(function (prevState) {
        var prevContentModalVisible = prevState.contentModalVisible;

        if (prevContentModalVisible) {
          var purchaseDataCallback = _this.state.purchaseDataCallback; // tslint:disable-next-line: no-unused-expression

          purchaseDataCallback && purchaseDataCallback(_this.state.purchaseData.outputGroupId);
        }

        return {
          contentModalVisible: !prevContentModalVisible
        };
      });
    };

    _this.showContent = function (contentItem, purchaseData, purchaseDataCallback) {
      // fetch the data or display it
      var hasContent = _this.hasContent(contentItem);

      if (!hasContent) {
        _this.props.getPageContent(contentItem);
      }

      _this.setState(function (prevState) {
        return {
          purchaseDataCallback: purchaseDataCallback,
          currentContent: contentItem,
          purchaseData: purchaseData ? __assign({}, purchaseData) : __assign({}, prevState.purchaseData),
          contentModalVisible: !prevState.contentModalVisible
        };
      });
    };

    _this.navigate = function (route, navigationExtraParams) {
      if (navigationExtraParams === void 0) {
        navigationExtraParams = {};
      }

      _this.props.navigateTo(route, navigationExtraParams);
    };

    _this.renderChildren = function () {
      var children = _this.props.children;

      if (typeof children === 'function') {
        return children({
          showContent: _this.showContent
        });
      }

      return children;
    };

    _this.renderContentContainer = function () {
      var _a = _this.props,
          IFrameComponent = _a.IFrameComponent,
          WebViewComponent = _a.WebViewComponent,
          pageContent = _a.pageContent;
      var _b = _this.state,
          contentModalVisible = _b.contentModalVisible,
          currentContent = _b.currentContent;

      var hasContent = _this.hasContent(currentContent);

      return react_1.default.createElement(components_lib_1.ContentPageModal, {
        visible: contentModalVisible,
        closeAction: _this.toggleModal,
        scrollable: true
      }, function () {
        if (!hasContent) return react_1.default.createElement(components_lib_1.LoadingIndicator, {
          size: "small"
        });

        if (currentContent !== enums_1.ContentPagesEnum.payment) {
          var _a = pageContent[currentContent],
              content = _a.content,
              lastModified = _a.lastModified,
              pageTitle = _a.pageTitle;
          return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(components_lib_1.Title, {
            centered: true
          }, pageTitle), react_1.default.createElement(LabelContainer, null, react_1.default.createElement(components_lib_1.Label, null, "Last updated on ", lastModified)), react_1.default.createElement(WebViewComponent, {
            scrollEnabled: true,
            source: {
              html: content
            }
          }));
        }

        var _b = _this.state.purchaseData,
            personId = _b.personId,
            outputGroupId = _b.outputGroupId; // we want the purchase module to be recreated every time
        // due to an issue with the OptimumHQ payment process

        if (!contentModalVisible) return null;
        return react_1.default.createElement(payments_1.PurchaseModule, {
          personId: personId,
          outputGroupId: outputGroupId,
          IFrameComponent: IFrameComponent
        });
      });
    };

    return _this;
  }

  WithAdditionalContent.prototype.hasContent = function (contentItem) {
    // we don't need additional content for the payments
    if (contentItem === enums_1.ContentPagesEnum.payment) {
      return true;
    }

    var pageContent = this.props.pageContent;
    return !utilities_1.isEmpty(pageContent[contentItem]);
  };

  WithAdditionalContent.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        includeFooter = _a.includeFooter,
        activeBreakpoint = _a.activeBreakpoint,
        navigationExtraParams = _a.navigationExtraParams;
    var small = responsive_1.isSmall(activeBreakpoint);
    return react_1.default.createElement(react_1.default.Fragment, null, this.renderContentContainer(), this.renderChildren(), includeFooter && !small ? react_1.default.createElement(components_lib_1.Footer, {
      privacyAction: function privacyAction() {
        return _this.showContent(enums_1.ContentPagesEnum.privacy);
      },
      termsAction: function termsAction() {
        return _this.showContent(enums_1.ContentPagesEnum.terms);
      },
      contactUsAction: function contactUsAction() {
        return _this.navigate(routes_1.RoutesKeysEnum.contact, navigationExtraParams);
      }
    }) : null);
  };

  WithAdditionalContent.defaultProps = {
    navigationExtraParams: {}
  };
  return WithAdditionalContent;
}(react_1.default.Component);

var LabelContainer = styled_components_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    text-align: center;\n"], ["\n    text-align: center;\n"])));

var mapStateToProps = function mapStateToProps(state) {
  return {
    pageContent: store_1.pageContentSelector(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getPageContent: redux_1.bindActionCreators(store_1.getPageContentActionCreator, dispatch)
  };
};

var connector = react_redux_1.connect(mapStateToProps, mapDispatchToProps);
var hoc = redux_1.compose(connector, responsive_1.withResponsiveMeta, core_1.withNavigateTo);
exports.default = hoc(WithAdditionalContent);
var templateObject_1;